module.exports = __webpack_public_path__ + "img/mariaColor.56fcbb26.png";